function hasProse(value) {
  return typeof value === 'string' && value.trim().length > 0;
}

function hasList(value) {
  return Array.isArray(value) && value.length > 0;
}

function isPlainObject(value) {
  return value !== null && typeof value === 'object' && !Array.isArray(value);
}

function firstItem(arr) {
  return Array.isArray(arr) && arr.length > 0 ? arr[0] : null;
}

function itemHasKeys(item, keys) {
  return isPlainObject(item) && keys.every((k) => k in item);
}

export const CONTENT_TYPES = {
  PROSE: 'prose',
  SCENARIO_DIMENSIONS: 'scenario_dimensions',
  OPEN_QUESTIONS: 'open_questions',
  METHODOLOGICAL_CHOICES: 'methodological_choices',
  EXPERTS: 'experts',
  RECOMMENDED_VIEWS: 'recommended_views',
  REFERENCES: 'references',
  FINDINGS: 'findings',
  UNKNOWN: 'unknown',
};

export function payloadHasRenderableContent(contentType, payload) {
  if (payload == null) return false;

  switch (contentType) {
    case CONTENT_TYPES.PROSE:
      return hasProse(payload);
    case CONTENT_TYPES.SCENARIO_DIMENSIONS:
    case CONTENT_TYPES.OPEN_QUESTIONS:
    case CONTENT_TYPES.METHODOLOGICAL_CHOICES:
    case CONTENT_TYPES.EXPERTS:
    case CONTENT_TYPES.RECOMMENDED_VIEWS:
    case CONTENT_TYPES.REFERENCES:
      return hasList(payload);
    case CONTENT_TYPES.FINDINGS:
      return hasProse(payload) || hasList(payload);
    default:
      return hasProse(payload) || hasList(payload) || isPlainObject(payload);
  }
}

/**
 * Infer how to render a YAML value from its shape (not from the key name).
 */
export function inferContentType(payload) {
  if (hasProse(payload)) {
    return CONTENT_TYPES.PROSE;
  }

  if (!hasList(payload)) {
    return CONTENT_TYPES.UNKNOWN;
  }

  const sample = firstItem(payload);
  if (!isPlainObject(sample)) {
    return CONTENT_TYPES.UNKNOWN;
  }

  if (itemHasKeys(sample, ['question'])) {
    return CONTENT_TYPES.OPEN_QUESTIONS;
  }

  if (itemHasKeys(sample, ['axis'])) {
    return CONTENT_TYPES.METHODOLOGICAL_CHOICES;
  }

  if (itemHasKeys(sample, ['name', 'states'])) {
    return CONTENT_TYPES.SCENARIO_DIMENSIONS;
  }

  if (itemHasKeys(sample, ['name']) && (sample.affiliation != null || sample.role != null)) {
    return CONTENT_TYPES.EXPERTS;
  }

  if (itemHasKeys(sample, ['label'])) {
    return CONTENT_TYPES.RECOMMENDED_VIEWS;
  }

  if (itemHasKeys(sample, ['title'])) {
    return CONTENT_TYPES.REFERENCES;
  }

  return CONTENT_TYPES.UNKNOWN;
}

export { hasProse, hasList };
